export default __webpack_public_path__ + "static/media/checkers-3-lqMAX.58e8cbdc.jpg";